/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Correct_ScoreInputs */

const th_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แก้ไข`)
};

const en_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correct`)
};

const ja_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`修正`)
};

const zh_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更正`)
};

const es_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corregir`)
};

const pt_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir`)
};

const id_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbaiki`)
};

const fr_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriger`)
};

const tl_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itama`)
};

const vi_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa`)
};

const ko_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`수정`)
};

const de_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korrigieren`)
};

const ru_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Исправить`)
};

const tr_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Düzelt`)
};

const it_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correggi`)
};

const pl_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Popraw`)
};

const uk_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Виправити`)
};

const hi_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सुधारें`)
};

const ar_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصحيح`)
};

const ms_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betulkan`)
};

const bn_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংশোধন`)
};

const zh_tw2_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更正`)
};

const zh_hk2_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更正`)
};

const ur_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`درست کریں`)
};

const fa_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اصلاح`)
};

const sw_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahihisha`)
};

const nl_correct_score = /** @type {(inputs: Correct_ScoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigeren`)
};

/**
* | output |
* | --- |
* | "Correct" |
*
* @param {Correct_ScoreInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const correct_score = /** @type {((inputs?: Correct_ScoreInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Correct_ScoreInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_correct_score(inputs)
	if (locale === "ja") return ja_correct_score(inputs)
	if (locale === "zh") return zh_correct_score(inputs)
	if (locale === "es") return es_correct_score(inputs)
	if (locale === "pt") return pt_correct_score(inputs)
	if (locale === "id") return id_correct_score(inputs)
	if (locale === "fr") return fr_correct_score(inputs)
	if (locale === "tl") return tl_correct_score(inputs)
	if (locale === "vi") return vi_correct_score(inputs)
	if (locale === "ko") return ko_correct_score(inputs)
	if (locale === "de") return de_correct_score(inputs)
	if (locale === "ru") return ru_correct_score(inputs)
	if (locale === "tr") return tr_correct_score(inputs)
	if (locale === "it") return it_correct_score(inputs)
	if (locale === "pl") return pl_correct_score(inputs)
	if (locale === "uk") return uk_correct_score(inputs)
	if (locale === "hi") return hi_correct_score(inputs)
	if (locale === "ar") return ar_correct_score(inputs)
	if (locale === "ms") return ms_correct_score(inputs)
	if (locale === "bn") return bn_correct_score(inputs)
	if (locale === "zh-TW") return zh_tw2_correct_score(inputs)
	if (locale === "zh-HK") return zh_hk2_correct_score(inputs)
	if (locale === "ur") return ur_correct_score(inputs)
	if (locale === "fa") return fa_correct_score(inputs)
	if (locale === "sw") return sw_correct_score(inputs)
	if (locale === "nl") return nl_correct_score(inputs)
	return en_correct_score(inputs)
});